import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Particle from "../Particle";
import {
  AiOutlinePrinter,
  AiOutlineHome,
  AiOutlineDownload,
  AiOutlineMail,
  AiOutlinePhone,
  AiOutlineEnvironment,
  AiOutlineGlobal,
} from "react-icons/ai";
import { BsGithub, BsLinkedin } from "react-icons/bs";
import { Link } from "react-router-dom";
import myImg from "../../Assets/avatar.jpg";

function ResumeNew() {
  const downloadLatestCv = () => {
    window.print();
  };

  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />
        
        {/* CV Actions Bar */}
        <Row className="justify-content-center resume-actions mb-4 no-print">
          <Col xs="auto">
            <Button className="resume-action-primary" onClick={downloadLatestCv}>
              <AiOutlineDownload />
              &nbsp;Download CV
            </Button>
          </Col>
          <Col xs="auto">
            <Button
              className="resume-action-secondary"
              onClick={() => window.print()}
            >
              <AiOutlinePrinter />
              &nbsp;Print / Save PDF
            </Button>
          </Col>
          <Col xs="auto">
            <Button
              as={Link}
              to="/"
              className="resume-action-secondary"
            >
              <AiOutlineHome />
              &nbsp;Back to Home
            </Button>
          </Col>
        </Row>

        {/* CV Paper Container */}
        <Container className="cv-paper">
          <Row className="g-0">
            {/* Left Sidebar */}
            <Col md={4} className="cv-sidebar">
              <div className="cv-avatar-container text-center">
                <img src={myImg} alt="avatar" className="img-fluid cv-avatar" />
              </div>
              
              <div className="cv-sidebar-section">
                <h3 className="cv-sidebar-title">Contact</h3>
                <ul className="cv-contact-list">
                  <li>
                    <span className="cv-contact-icon"><AiOutlinePhone /></span>
                    <span><strong>Phone</strong><a href="tel:+84345841819">0345 841 819</a></span>
                  </li>
                  <li>
                    <span className="cv-contact-icon"><AiOutlineMail /></span>
                    <span><strong>Email</strong><a href="mailto:dntienes@gmail.com">dntienes@gmail.com</a></span>
                  </li>
                  <li>
                    <span className="cv-contact-icon"><AiOutlineEnvironment /></span>
                    <span><strong>Location</strong>Ho Chi Minh City, Vietnam</span>
                  </li>
                  <li>
                    <span className="cv-contact-icon"><BsGithub /></span>
                    <span><strong>GitHub</strong><a href="https://github.com/NgocTien0110" target="_blank" rel="noreferrer">NgocTien0110</a></span>
                  </li>
                  <li>
                    <span className="cv-contact-icon"><BsLinkedin /></span>
                    <span><strong>LinkedIn</strong><a href="https://www.linkedin.com/in/ngoctien0110/" target="_blank" rel="noreferrer">ngoctien0110</a></span>
                  </li>
                  <li>
                    <span className="cv-contact-icon"><AiOutlineGlobal /></span>
                    <span><strong>Portfolio</strong><a href="https://ngoctien.vercel.app/" target="_blank" rel="noreferrer">ngoctien.vercel.app</a></span>
                  </li>
                </ul>
              </div>

              <div className="cv-sidebar-section">
                <h3 className="cv-sidebar-title">Skills</h3>
                <div className="cv-skill-group">
                  <h4>Core Languages</h4>
                  <div className="cv-tags">
                    <span className="cv-tag">Java</span>
                    <span className="cv-tag">SQL</span>
                    <span className="cv-tag">JavaScript</span>
                    <span className="cv-tag">Python</span>
                    <span className="cv-tag">C++</span>
                  </div>
                </div>

                <div className="cv-skill-group">
                  <h4>Frameworks & Tech</h4>
                  <div className="cv-tags">
                    <span className="cv-tag">Spring Boot</span>
                    <span className="cv-tag">Apache Kafka</span>
                    <span className="cv-tag">Elasticsearch</span>
                    <span className="cv-tag">Hibernate</span>
                    <span className="cv-tag">MongoDB</span>
                    <span className="cv-tag">PostgreSQL</span>
                    <span className="cv-tag">Oracle DB</span>
                    <span className="cv-tag">Redis</span>
                    <span className="cv-tag">Docker</span>
                    <span className="cv-tag">gRPC</span>
                    <span className="cv-tag">Feign Client</span>
                    <span className="cv-tag">REST API</span>
                  </div>
                </div>

                <div className="cv-skill-group">
                  <h4>Tools & Platforms</h4>
                  <div className="cv-tags">
                    <span className="cv-tag">Git & GitHub</span>
                    <span className="cv-tag">IntelliJ IDEA</span>
                    <span className="cv-tag">VS Code</span>
                    <span className="cv-tag">Postman</span>
                    <span className="cv-tag">Jenkins</span>
                    <span className="cv-tag">Linux</span>
                  </div>
                </div>
              </div>

              <div className="cv-sidebar-section">
                <h3 className="cv-sidebar-title">Languages</h3>
                <ul className="cv-sidebar-list">
                  <li><strong>Vietnamese:</strong> Native</li>
                  <li><strong>English:</strong> Reading technical documents</li>
                </ul>
              </div>
            </Col>

            {/* Right Main Content */}
            <Col md={8} className="cv-main">
              <div className="cv-header">
                <span className="cv-eyebrow">Backend Engineer · Ho Chi Minh City</span>
                <h1 className="cv-name">Đặng Ngọc Tiến</h1>
                <h2 className="cv-headline">Middle Java Backend Developer</h2>
                <div className="cv-header-highlights">
                  <span><strong>3+</strong> years experience</span>
                  <span><strong>Java</strong> & Spring Boot</span>
                  <span><strong>Microservices</strong> & Event-driven</span>
                </div>
              </div>

              <div className="cv-section">
                <h3 className="cv-section-title">Professional Summary</h3>
                <p className="cv-section-text">
                  Detail-oriented Backend Developer with over 3 years of hands-on experience building scalable enterprise systems using <strong>Java</strong>, <strong>Spring Boot</strong>, <strong>Kafka</strong>, and relational databases (<strong>PostgreSQL</strong>, <strong>Oracle</strong>). Strong expertise in designing microservices, optimizing database queries, and implementing event-driven architectures. Currently contributing to performance-critical traffic management and government-scale applications where stability, security, and scalability are crucial.
                </p>
              </div>

              <div className="cv-section">
                <h3 className="cv-section-title">Work Experience</h3>
                <div className="cv-item">
                  <div className="cv-item-header">
                    <h4 className="cv-item-role">Java Backend Developer</h4>
                    <span className="cv-item-date">2023 - Present</span>
                  </div>
                  <div className="cv-item-subtitle">GTEL OTS | VneTraffic Project (Traffic Management System)</div>
                  <ul className="cv-item-bullets">
                    <li>Designed and implemented secure microservices using Java and Spring Boot for the VneTraffic national scale project, improving processing capacity.</li>
                    <li>Integrated Apache Kafka pipelines to handle high-throughput real-time traffic sensor data and event messaging.</li>
                    <li>Analyzed and optimized complex SQL queries and PL/SQL procedures on Oracle Database to resolve performance bottlenecks.</li>
                    <li>Utilized Docker containerization and automated Jenkins workflows to maintain stable production deployments.</li>
                  </ul>
                </div>

                <div className="cv-item">
                  <div className="cv-item-header">
                    <h4 className="cv-item-role">Junior Developer & Intern</h4>
                    <span className="cv-item-date">2022 - 2023</span>
                  </div>
                  <div className="cv-item-subtitle">Academic Projects & Applications</div>
                  <ul className="cv-item-bullets">
                    <li>Built desktop automation, monitoring tools, and bus ticket reservation portals, gaining hands-on software design experience.</li>
                    <li>Solidified core computer science fundamentals including OOP, Data Structures, Algorithms, and Software Engineering processes.</li>
                  </ul>
                </div>
              </div>

              <div className="cv-section">
                <h3 className="cv-section-title">Selected Projects</h3>
                <div className="cv-project-grid">
                <div className="cv-project-item">
                  <div className="cv-project-header">
                    <a href="https://airi-tools.vercel.app/" target="_blank" rel="noreferrer"><strong>Ti Tools</strong></a>
                    <span>Next.js, Firebase, PDF.js</span>
                  </div>
                  <p className="cv-project-desc">
                    A privacy-first browser workspace with 20+ developer and document tools, including JWT, QR, Excel/PDF, OCR, and image utilities.
                  </p>
                </div>

                <div className="cv-project-item">
                  <div className="cv-project-header">
                    <a href="https://github.com/ngoc-thu/shimeji-ubuntu" target="_blank" rel="noreferrer"><strong>Shimeji Ubuntu</strong></a>
                    <span>Linux, Shell, Python</span>
                  </div>
                  <p className="cv-project-desc">
                    A desktop customization project for Ubuntu inspired by Shimeji-style companion characters, bringing playful interactive elements to the Linux desktop experience.
                  </p>
                </div>

                <div className="cv-project-item">
                  <div className="cv-project-header">
                    <strong>Gõ Mõ Online 3D</strong>
                    <span>Three.js, Firebase, WebGL</span>
                  </div>
                  <p className="cv-project-desc">
                    An interactive 3D stress-relief application incorporating real-time global leaderboards, combo streaks, and authentication.
                  </p>
                </div>

                <div className="cv-project-item">
                  <div className="cv-project-header">
                    <strong>Ticket4T</strong>
                    <span>React, Express, PostgreSQL</span>
                  </div>
                  <p className="cv-project-desc">
                    An online ticket booking platform featuring user authentication, payment flows, and ticket reservation management.
                  </p>
                </div>
                </div>
              </div>

              <div className="cv-section">
                <h3 className="cv-section-title">Education</h3>
                <div className="cv-item">
                  <div className="cv-item-header">
                    <h4 className="cv-item-degree">Bachelor of Science in Software Engineering</h4>
                    <span className="cv-item-date">2020 - 2024</span>
                  </div>
                  <div className="cv-item-institution">VNU HCMC - University of Science</div>
                  <div className="cv-item-gpa">Overall GPA: <strong>3.47 / 4.00</strong></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}

export default ResumeNew;
